import type { BasicCouponFragment } from '@drycut/graphql';

type Props = {
  coupon: BasicCouponFragment | undefined;
  kidCustomer: boolean;
  service: null | undefined | { kidsPrice?: null | number | undefined; price: number };
  tax?: number;
};

export function computeBookingPrice({
  tax = 0,
  service,
  coupon,
  kidCustomer = false,
}: Props): number {
  // If there is a coupon and the coupon price is 0, the booking is free. Otherwise we need to add
  // the tax to the coupon price.
  if (coupon) {
    return coupon.price === 0 ? 0 : coupon.price + tax;
  }

  if (kidCustomer && service?.kidsPrice) {
    return service.kidsPrice;
  }

  return (service?.price || 0) + tax;
}
